import * as React from "react";
import { useState, useMemo, useCallback } from "react";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { useCards } from "../../../../../../reactQuery/cards";
import DownArrow from "../../../../../../styles/svg/downArrow.svg";
import { updateParentCard } from "../../../../../../services/apiCards";
import DropdownWithSearchbar from "../../../../../../components/DropdownWithSearchbar";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import FormDialog from "../../../../../../components/Dialog/FormDialog";
import { CustomButton } from "../../../../../../components/Button/Button";
import useMutate from "../../../../../../hooks/useMutate";

const isDependsOnDropdown = (prevProps, nextProps) => {
  const prevCardData = prevProps?.card?.data?.data?.responseData;
  const nextCardData = nextProps?.card?.data?.data?.responseData;
  return (
    prevProps.cardId === nextProps.cardId &&
    prevCardData?.board_id === nextCardData?.board_id &&
    prevCardData?.parent_card_id === nextCardData?.parent_card_id
  );
};

export default React.memo(function DependsOnDropdown({ cardId, card }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [changeParentDialog, setChangeParentDialog] = useState(false);
  const [parentId, setParentId] = useState(null);
  const open = Boolean(anchorEl);
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");

  const [loading, setLoading] = useState(false);
  const { parent_card_id, board_id } = card?.data?.data?.responseData;
  const { isLoading, cards, isError } = useCards(board_id);
  const data = cards?.data?.data?.responseData || [];

  const filteredCards = useMemo(
    () =>
      data?.filter(
        (item) =>
          item?.card?.card_id !== cardId &&
          item?.card?.card_id !== parent_card_id &&
          !item?.card?.parent_card_id &&
          !item?.sub_tasks?.some(
            (subtaskItem) => subtaskItem === item?.card?.card_id
          ) &&
          (item?.key + "-" + item?.card?.card_id)
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      ) || [],
    [data, cardId, parent_card_id, searchQuery]
  );

  const { mutate: updateCardmutate } = useMutate(updateParentCard,
    ['card', 'mineCards', 'watching'],
    ()=>{},
    () => {
      setLoading(false);
      queryClient.invalidateQueries({
        queryKey: [`cards`, board_id],
      });
      queryClient.invalidateQueries({
        queryKey: [`cards`, String(board_id)],
      });
      queryClient.invalidateQueries({
        queryKey: [`cards`, Number(board_id)],
      });
      
      queryClient.invalidateQueries({
        queryKey: [`card`, Number(cardId)],
      });
      
      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });

      queryClient.invalidateQueries({
        queryKey: [`mineCards`],
      });queryClient.invalidateQueries({
        queryKey: [`userCards`],
      });queryClient.invalidateQueries({
        queryKey: [`assignedCards`],
      });
      queryClient.invalidateQueries({
        queryKey: [`watching`],
      });
      
      setChangeParentDialog(false);
    },
    () => {
      setLoading(false);
    },
  );

  const handleDependsClose = useCallback((cardId) => {
    setParentId(cardId);
    setChangeParentDialog(true);
  }, []);

 const handleChangeParent = useCallback(() => {
    setLoading(true);
    updateCardmutate({
      card_id: cardId,
      parent_card_id: parentId,
    });
  }, [cardId, parentId, updateCardmutate]);

  const handleAnchorClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleDialogClose = useCallback(() => {
    setChangeParentDialog(false);
  }, []);

  return (
    <>
      {changeParentDialog && (
        <FormDialog
          open={changeParentDialog}
          handleClose={handleDialogClose}
          loading={loading}
          handleSubmit={handleChangeParent}
          buttonTxt="change"
          title={parentId === 0 ? "Remove parent" : "Parent Task Change"}
          cancelBtn={true}
          alignActions={"center"}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            {parentId === 0
              ? "Are you sure you want to delete the parent?"
              : "Are you sure you want to change parent task."}
          </Typography>
        </FormDialog>
      )}
      <div className={!isMobile && `mr-2`}>
        <CustomButton
          variant="outlined"
          color="primary"
          id="epics-board-dropdown"
          aria-haspopup="true"
          onClick={handleAnchorClick}
          fullWidth={isMobile}
          className={`depends-dropdown-btn white-button ${!isMobile && "ml-1"}`}
          endIcon={<img src={DownArrow} alt="" />}
        >
          <p
            className={`header-action-button-text flex-grow-1 ${
              !isMobile && "mr-1"
            }`}
          >
            {parent_card_id ? "Change Parent" : "Assign Parent"}
          </p>
        </CustomButton>

        <DropdownWithSearchbar
          anchorEl={anchorEl}
          open={open}
          setAnchorEl={setAnchorEl}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          filteredCards={filteredCards}
          handleConfirmationPopup={handleDependsClose}
          renderItemLabel={(item) => `${item.key}-${item.card.card_id}`}
          isToolTip={true}
        />
      </div>
    </>
  );
}, isDependsOnDropdown)
